import { Plus, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AuTimeInput } from "@/components/AuDateTime";

/** Repeating daily breaks [{start,end}] (HH:MM). value null = inherit (when inheritLabel given). */
export const DailyBreaksEditor = ({ value, onChange, inheritLabel, testid = "daily-breaks" }) => {
  const inherit = value === null || value === undefined;
  const rows = inherit ? [] : value;
  const update = (i, k, v) => onChange(rows.map((r, j) => (j === i ? { ...r, [k]: v } : r)));
  return (
    <div className="space-y-2" data-testid={testid}>
      {inheritLabel && (
        <label className="flex items-center gap-2 text-xs text-slate-600">
          <input type="checkbox" checked={inherit} onChange={(e) => onChange(e.target.checked ? null : [])} data-testid={`${testid}-inherit`} />
          {inheritLabel}
        </label>
      )}
      {!inherit && rows.map((r, i) => (
        <div key={i} className="flex items-center gap-2" data-testid={`${testid}-row-${i}`}>
          <AuTimeInput value={r.start || ""} onChange={(e) => update(i, "start", e.target.value)} className="w-32" data-testid={`${testid}-start-${i}`} />
          <span className="text-xs text-slate-400">to</span>
          <AuTimeInput value={r.end || ""} onChange={(e) => update(i, "end", e.target.value)} className="w-32" data-testid={`${testid}-end-${i}`} />
          <Button type="button" variant="ghost" size="sm" onClick={() => onChange(rows.filter((_, j) => j !== i))} data-testid={`${testid}-remove-${i}`}>
            <X className="h-4 w-4" />
          </Button>
        </div>
      ))}
      {!inherit && (
        <Button type="button" variant="outline" size="sm" onClick={() => onChange([...rows, { start: "12:00", end: "12:30" }])} data-testid={`${testid}-add`}>
          <Plus className="h-4 w-4 mr-1" /> Add break
        </Button>
      )}
    </div>
  );
};
